import { SocialProviders } from 'Types/common';
import { SocialButtonProps } from './types';
import * as Styled from './styles';

const SOCIAL_ICONS = {
  [SocialProviders.GOOGLE]: 'GoogleLight',
  [SocialProviders.FACEBOOK]: 'Facebook',
};

const SocialButton = ({ onClick, label, type }: SocialButtonProps): JSX.Element => {
  const Icon = SOCIAL_ICONS[type];
  return (
    <Styled.SocialButton
      size="l"
      label={label}
      mode="secondary"
      onClick={onClick}
      className="btn-social"
      data-testid={type}
      iconStart={Icon}
    />
  );
};

export default SocialButton;
